import { create } from 'zustand';

const getInitialMode = () => {
  try {
    const saved = localStorage.getItem('admin_theme_mode');
    if (saved === 'light' || saved === 'dark' || saved === 'system') {
      return saved;
    }
    const legacy = localStorage.getItem('admin_theme');
    if (legacy) {
      return JSON.parse(legacy) ? 'dark' : 'light';
    }
  } catch (e) {}
  return 'system';
};

export const useThemeStore = create((set, get) => ({
  mode: 'system', // 'light' | 'dark' | 'system'
  dark: false, // For backward compatibility
  
  setMode: (mode) => {
    localStorage.setItem('admin_theme_mode', mode);
    set({ mode });
    get().applyTheme();
  },
  
  toggle: () => {
    const isCurrentlyDark = get().dark;
    get().setMode(isCurrentlyDark ? 'light' : 'dark');
  },
  
  applyTheme: () => {
    const { mode } = get();
    let isDark = false;
    
    if (mode === 'system') {
      isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    } else {
      isDark = mode === 'dark';
    }
    
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    
    // Update legacy boolean
    set({ dark: isDark });
    // Update legacy storage for compat
    localStorage.setItem('admin_theme', JSON.stringify(isDark));
  },
  
  init: () => {
    const mode = getInitialMode();
    set({ mode });
    get().applyTheme();
    
    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      if (get().mode === 'system') {
        get().applyTheme();
      }
    };
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler);
    } else {
      mediaQuery.addListener(handler); // fallback
    }
  }
}));